import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { BackToTopButton } from 'components/no-auth/common/back-to-top-button/BackToTopButton';
import { Breadcrumbs } from 'components/no-auth/common/breadcrumbs/Breadcrumbs';
import ColoredSectionContainer from 'components/no-auth/common/ColoredSectionContainer';
import { Date } from 'components/no-auth/common/date/Date';
import { LightButton } from 'components/no-auth/common/fromAuth/LightButton/LightButton';
import { LightFixedBottomPanel } from 'components/no-auth/common/fromAuth/LightFixedBottomPanel/LightFixedBottomPanel';
import { PromoDangerouslyHtml } from 'components/no-auth/common/promo-dangerously-html/PromoDangerouslyHtml';
import { PromoPageContainer } from 'components/no-auth/common/promo-page-container/PromoPageContainer';
import { PromoRow } from 'components/no-auth/common/PromoRow/PromoRow';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { TextComponent } from 'components/no-auth/common/sections/styles';
import ZendeskHelpSearch from 'components/no-auth/help/ZendeskHelpSearch';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

import { toggleChat } from 'actions/chatAction';

import { getLangCountryPrefix, getYYYYMMDDDate } from 'helpers/utils';

const ZendeskHelpArticlePage = (props) => {
    let { sectionId } = useParams();
    const sectionIdNumber = Number(sectionId);
    const category = props.category;
    const section = props.sections.find((s) => s.id === sectionIdNumber);
    const article = props.article;

    const url = `${getLangCountryPrefix(props.lang, props.country)}/help`;

    const breadcrumbs = [
        { name: 'Paysend', url: url },
        { name: category.name, url: `${url}/category/${category.id}` },
        { name: section.name, url: `${url}/category/${category.id}/section/${section.id}` },
        { name: article?.title },
    ];

    const date = getYYYYMMDDDate(article?.created_at);

    return (
        <PromoPageContainer hasTopPadding>
            <ColoredSectionContainer dimension="average" bottomPadding noTopPadding>
                <ZendeskHelpSearch />
                <Breadcrumbs breadcrumbsItems={breadcrumbs} />
                <HeadingSection title={article?.title} titleTag={'h1'} />
                <PromoRow indent="adaptive-32-48-64">
                    <Date date={date} />
                </PromoRow>
                <PromoRow indent="64px">
                    <TextComponent linksHighlited>
                        <PromoDangerouslyHtml color="gray80" dangerouslyHtml={article?.body} />
                    </TextComponent>
                </PromoRow>
                <BackToTopButton caption={props.backToTop} />
            </ColoredSectionContainer>
            {props.showZendeskChat && (
                <LightFixedBottomPanel pressedAboveCookieButton>
                    <LightButton raised={true} caption={props.chatButton} onClick={() => props.toggleChat(true)} />
                </LightFixedBottomPanel>
            )}
        </PromoPageContainer>
    );
};

const mapStateToProps = ({ extra }) => ({
    chatButton: extra?.strapiApi?.chat_btn,
    backToTop: extra?.strapiApi?.back_to_top_btn,
    category: extra?.zendeskHelpData?.category,
    sections: extra?.zendeskHelpData?.sections,
    article: extra?.zendeskHelpData?.article,
    lang: extra.noAuthFooter?.language?.lang,
    country: extra.noAuthFooter?.language?.country,
    showZendeskChat: extra?.noAuthFooter?.showZendeskChat,
});

export default connect(mapStateToProps, { toggleChat })(NotAuthBasePage(ZendeskHelpArticlePage));
